/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import CreateAppointmentAfter from './CreateAppointmentAfter/index'
import React from 'react'
import Templates from './Templates/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/FutureSeparator/Actions/AddAppointment/Add/Content/AppointmentTypes/Content"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Templates
  viewPath={`${viewPath}/Templates`}
/>
<CreateAppointmentAfter
  viewPath={`${viewPath}/CreateAppointmentAfter`}
/>
</div>
{children}
</React.Fragment>)
}